
import { create } from 'zustand';

const normalizePart = (value = '') => String(value).toLowerCase().replace(/[^a-z0-9]/g, '');

const toCandidates = (permission) => {
    const raw = String(permission || '').trim();
    if (!raw) return [];

    const parts = raw.split(/[._]/).map((p) => p.trim()).filter(Boolean);
    if (parts.length >= 2) {
        const action = normalizePart(parts[0]);
        const resource = normalizePart(parts.slice(1).join(''));
        return [raw, `${action}.${resource}`];
    }

    return [raw, normalizePart(raw)];
};

export const userPermssionsStore = create((set, get) => ({
    permissions: [],
    normalizedPermissions: new Set(),
    permissionsLoaded: false,

    setPermissions: (permissions = []) => {
        const normalizedPermissions = new Set();

        permissions.forEach((permission) => {
            const candidates = toCandidates(permission);
            candidates.forEach((candidate) => normalizedPermissions.add(candidate));
        });

        set({ permissions, normalizedPermissions, permissionsLoaded: true });
    },

    clearPermissions: () => set({ permissions: [], normalizedPermissions: new Set(), permissionsLoaded: false }),

    hasPermissions: (permissionToCheck) => {
        const checks = Array.isArray(permissionToCheck) ? permissionToCheck : [permissionToCheck];
        const normalizedPermissions = get().normalizedPermissions;

        return checks.some((permission) => {
            const candidates = toCandidates(permission);
            return candidates.some((candidate) => normalizedPermissions.has(candidate));
        });
    },

    can: (action, resource) => {
        if (!action || !resource) return false;
        return get().hasPermissions(`${action}.${resource}`);
    },

    canAdd: (resource) => get().can('add', resource),
    canUpdate: (resource) => get().can('update', resource),
    canDelete: (resource) => get().can('delete', resource),
    canView: (resource) => get().can('view', resource),

    canAccessResource: (resource) => {
        const actions = ['view', 'add', 'update', 'delete'];
        return actions.some((action) => get().can(action, resource));
    },
}));